import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { ProposalPdf } from '../components/proposal-pdf/proposal-pdf.model'
interface Approval {
    id: string
    approved: boolean
}
@Injectable({ providedIn: 'root' })
export class ProposalPdfService {
    public proposalPdfSubject = new BehaviorSubject<ProposalPdf | null>(null)
    public approvalSubject = new BehaviorSubject<Approval | null>(null)
    public onResetProposalSubject = new BehaviorSubject<Boolean>(false)
}
